import { Injectable } from "@angular/core";
import { BackgroundMode } from '@ionic-native/background-mode';
import { Subscription } from "rxjs";
import { Platform } from "ionic-angular";

@Injectable()
export class BackgroundModeNative {
  private subscriptions: Array<Subscription> = [];
  constructor(private backgroundMode: BackgroundMode,
    private platform: Platform
  ) { }

  disableWebViewOptimizations() {
    if (this.platform.is('cordova') && this.platform.is('android')) {
      return this.backgroundMode.disableWebViewOptimizations();
    }

    return false;
  }

  enable() {
    this.listenActive();
    return this.backgroundMode.enable();
  }

  disable() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    return this.backgroundMode.disable();
  }

  listenActive() {
    this.subscriptions.push(
      this.backgroundMode.on('activate').subscribe(() => {
        this.disableWebViewOptimizations();
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/native/background-mode.native.ts